export default function checkExternalUrl(url) {
  if (!url) return '';
  return url.includes('http') ? url : `http://${url}`;
}
